'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';

export function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setStatus('loading');

    try {
      // In production, integrate with your email marketing service (Mailchimp, ConvertKit, etc.)
      const response = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('Thanks for subscribing! Check your email for confirmation.');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      }
    } catch {
      setStatus('error');
      setMessage('Failed to subscribe. Please try again later.');
    }

    setTimeout(() => {
      setStatus('idle');
      setMessage('');
    }, 5000);
  }

  return (
    <div className="bg-[color:var(--color-dark)] text-white py-12">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-3">
            Stay Updated with Plastering Tips & Special Offers
          </h2>
          <p className="text-gray-300 mb-6">
            Get expert maintenance tips, seasonal offers, and project inspiration delivered to your inbox.
          </p>
          
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="flex-1 px-4 py-3 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-yellow-400"
              disabled={status === 'loading'}
            />
            <Button
              type="submit"
              disabled={status === 'loading'}
              className="!h-12 px-6 py-3 !bg-yellow-600 hover:!bg-yellow-700 !text-white font-semibold rounded-md transition-colors disabled:opacity-50"
            >
              {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
            </Button>
          </form>

          {message && (
            <p
              className={`mt-4 text-sm ${
                status === 'success' ? 'text-green-300' : 'text-red-300'
              }`}
            >
              {message}
            </p>
          )}

          <p className="text-xs text-gray-300 mt-4">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </div>
    </div>
  );
}
